import { render, staticRenderFns } from "./MeasureColorDialog.vue?vue&type=template&id=4edadedd&scoped=true&"
import script from "./MeasureColorDialog.vue?vue&type=script&lang=js&"
export * from "./MeasureColorDialog.vue?vue&type=script&lang=js&"
import style0 from "./MeasureColorDialog.vue?vue&type=style&index=0&id=4edadedd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edadedd",
  null
  
)

component.options.__file = "MeasureColorDialog.vue"
export default component.exports